export class Contact {
  first_name = '';
  last_name = '';
  phone = '';
  email = '';
  is_optin = false;
  is_optin_pro = false;
  is_optin_parent = false;
  addresses?: any; // <-  TODO : RcPlaylistEdit refactoring ("War... war never change").

  constructor(contact?: any) {
    if (contact) {
      if (contact.first_name) this.first_name = contact.first_name;
      if (contact.last_name) this.last_name = contact.last_name;
      if (contact.phone) this.phone = contact.phone;
      if (contact.email) this.email = contact.email;
      if (contact.is_optin) this.is_optin = contact.is_optin;
      if (contact.is_optin_pro) this.is_optin_pro = contact.is_optin_pro;
      if (contact.is_optin_parent) this.is_optin_parent = contact.is_optin_parent;
      if (contact.addresses) this.addresses = contact.addresses;
    }
  }
}
